import script from "./HomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=213d089c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-213d089c"]])

export default __exports__